import { render, staticRenderFns } from "./FacetedSearch.vue?vue&type=template&id=0f831852&scoped=true"
import script from "./FacetedSearch.vue?vue&type=script&lang=js"
export * from "./FacetedSearch.vue?vue&type=script&lang=js"
import style0 from "./FacetedSearch.vue?vue&type=style&index=0&id=0f831852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f831852",
  null
  
)

export default component.exports